<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH TÀI KHOẢN CHĂM SÓC BÁN HÀNG</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <!-- <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới tài khoản</el-button
            > -->
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Tài khoản">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['account']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Trạng thái tài khoản">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['disabled']
                          "
                          placeholder="Chọn"
                          clearable
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <!-- <b-col md="4">
                      <el-form-item label="Quyền tài khoản">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['roles']"
                          disabled
                          multiple
                          placeholder="Chọn quyền"
                          @change="fn_change()"
                        >
                          <el-option
                            v-for="item in optionRoles"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col> -->
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="account"
                label="Tài khoản"
                min-width="200"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                prop="roles"
                label="Quyền tài khoản"
                min-width="200"
              >
                <!-- <template slot-scope="scope">
                  {{ scope.row.roles.join(" , ") }}
                </template> -->
              </el-table-column>
              <el-table-column
                label="Khóa tài khoản"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.disabled"
                    @change="fn_khoaAccount(scope.row, scope.row.disabled)"
                  ></el-checkbox>
                </template>
              </el-table-column>

              <el-table-column label="Thao tác" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormUser";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      rolesLength: 0,
      options: MethodService.copyObject(DataForm.options),
      optionRoles: MethodService.copyObject(DataForm.optionsRoles),
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filtersSale = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filtersSale
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filtersCustomerCareUser,
        fields: "id,account,disabled,roles",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachChamSocKhachHang",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filtersSale,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }

      try {
        const response = await mushroom.user.listAsync(dataFilter);
        if (response.result) {
          console.log(response.result);
          this.loading = false;
          let resData = await this.fn_changeData(response.result);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_changeData(data) {
      data.forEach((element) => {
        element.roles = element.roles.join(", ");
      });
      return data;
    },
    fn_change() {
      this.rolesLength = this.mData.tableRules.dataSearch.value.roles.length;
      console.log(this.rolesLength);
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietNguoiDung",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatNguoiDung",
          params: { id: row.id },
        });
      }
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachSale",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filtersSale,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filtersSale);
    },
    fn_tableSearch() {
      const string = "&roles:in:SalesUser";
      if (this.mData.tableRules.dataSearch.value["account"]) {
        this.mData.tableRules.dataSearch.value["account"] =
          this.mData.tableRules.dataSearch.value["account"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          if (this.rolesLength == 0) {
            this.mData.tableRules.filtersSale = "";
            this.mData.tableRules.filtersSale = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );
            this.mData.tableRules.filtersSale =
              this.mData.tableRules.filtersSale.replace("&roles:in:", "");
            this.mData.tableRules.filtersSale += string;
            console.log("261", this.mData.tableRules.filtersSale);
          } else {
            this.mData.tableRules.filtersSale = "";
            this.mData.tableRules.filtersSale = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );
          }
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // cập nhật trạng thái hiển thị/ẩn slide
    async fn_khoaAccount(row) {
      const user_object = {
        id: row.id,
        disabled: row.disabled,
      };
      try {
        const response = await mushroom.user.partialUpdateAsync(user_object);
        if (response.result == user_object.id) {
          window.toastr.success("Cập nhật trạng thái tài khoản thành công");
        } else console.log("Dữ liệu không thay đổi");
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_add() {
      this.$router.push({
        name: "ThemMoiNguoiDung",
      });
    },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
  },
  async mounted() {},
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
